module.exports = __webpack_public_path__ + "static/s-exam7-efd15d66980f653065a8e2ee34a735e9.png";